import FormErrors from "@/components/FormErrors/FormErrors.vue";
import { Editor, EditorContent } from "tiptap";
import { JSConn } from "@/utilities/js-conn";
import { v4 as uuidv4 } from "uuid";
import { WorkOrderDetailed } from "@/store/modules/workOrders";
import { buildSubmitButton } from "@/utilities/form-helpers";

import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "workOrderInstructionEditForm",
  props: {
    workOrderInstructionId: String,
  },
  components: {
    EditorContent,
    FormErrors,
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    let { submitButtonText, submitting } = buildSubmitButton();
    submitButtonText.value = "Submit";

    const instruction = reactive({
      content_json: {},
      description: "Basic Instructions",
      id: "",
      work_order_id: "",
    });

    const editor = ref<null | any>(null);
    const hasInstructionErrors = ref(false);
    const instructionErrors = ref<String[]>([]);

    const workOrder = computed(() => {
      return $store.getters.workOrder as WorkOrderDetailed;
    });

    onMounted(() => {
      // get the data from the store
      if (props.workOrderInstructionId === "new") {
        instruction.id = uuidv4();
        (instruction.content_json = {}),
          (instruction.description = "Basic instructions");
        instruction.work_order_id = workOrder.value.id;
      } else {
        const woInstruction = $store.getters.workOrderInstructionById(
          props.workOrderInstructionId,
        );
        instruction.id = woInstruction.id;
        instruction.content_json = woInstruction.content_json;
        instruction.description = woInstruction.description;
        instruction.work_order_id = workOrder.value.id;
      }

      editor.value = new Editor({
        autoFocus: true,
        content: instruction.content_json,
      });
    });

    const submitInstruction = (evt: any) => {
      evt.preventDefault();
      submitting.value = true;
      submitButtonText.value = "Submitting...";

      const jsConn = new JSConn();

      instruction.content_json = editor.value.getJSON();

      let storeDispatch;

      if (props.workOrderInstructionId === "new") {
        storeDispatch = "createWorkOrderInstruction";
      } else {
        storeDispatch = "updateWorkOrderInstruction";
      }

      jsConn.formParams = instruction;

      $store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          submitting.value = false;
          submitButtonText.value = "Submit";
          ctx.emit("instructionsChanged");

          // move to the list of instructions
          ctx.root.$router.push({
            name: "workOrderInstructions",
          });
        })
        .catch(jsConn => {
          hasInstructionErrors.value = true;
          instructionErrors.value = jsConn.error["response"]["data"];
        });
    };

    onUnmounted(() => {
      // always destroy the instance
      editor.value.destroy();
    });

    return {
      instruction,
      editor,

      hasInstructionErrors,
      instructionErrors,

      submitInstruction,
      submitButtonText,
      submitting,
    };
  },
});
